import { render, staticRenderFns } from "./user-record.vue?vue&type=template&id=ca73fc1e&scoped=true&"
import script from "./user-record.vue?vue&type=script&lang=js&"
export * from "./user-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca73fc1e",
  null
  
)

export default component.exports